import { useRequest } from '@10000/react'
import { Dialog } from './'
import { Form, Submit, Password } from '../../forms'
import { Box, H4, Icon } from '../'

export const PasswordDialog = ({ onClose, ...props }) => {
  const request = useRequest('tenant')

  const onSubmit = ({oldPassword, password }) => request('passwordSet', { oldPassword, password }).then(onClose)

  return <Dialog {...props} onClose={onClose} showControls={false} mobileBackground="white">
    <Form onSubmit={onSubmit} style={{ width: "100%" }}>
      <Box column fullWidth gap={24}>
        <H4 align="center" color="black">Change password</H4>

        <Password
          useCurrentPassword
          useConfirmedPassword
          dark
          showPasswordRequirements
        />

        <Box pt={8} fullWidth column gap={32}>
          <Box fullWidth height={1} background="black"/>
          <Submit>Update password</Submit>
        </Box>
      </Box>
      <Box position="absolute" top={16} right={16} cursor="pointer" onClick={onClose}>
        <Icon icon="Close" fill="black"/>
      </Box>
    </Form>
  </Dialog>
}